import { ValidatorResult } from '@/models/validation-result.model';
// TODO: SubscriptionsModel needs to be added to the index.ts file in the backstage-models
import { SubscriptionsModel } from '@onrunning/backstage-models/src/subscriptions.model';
import { Account } from '../models/account.model';
import { CrudService } from './crud.service';

export class UsersService {
  private crudService: CrudService<Account>;

  constructor() {
    this.crudService = new CrudService<Account>('users');
  }

  public updatePreferences(userPreferences: {
    theme: string;
    locale: string;
    subscriptions: SubscriptionsModel;
  }): Promise<ValidatorResult<void>> {
    return this.crudService.do('put', 'update-preferences', userPreferences, undefined, 'silent');
  }

  public async updateRelease(externalId: string): Promise<ValidatorResult<void>> {
    return this.crudService.do('put', `update-release?externalId=${externalId}`, undefined, undefined, 'silent');
  }

  public async unsubscribePaymentsEmail(unsubscribePaymentEmailToken: string, userId: string) {
    return this.crudService.do(
      'put',
      `user-notifications/unsubscribe?token=${unsubscribePaymentEmailToken}`,
      { userId },
      undefined,
      'silent',
    );
  }
}
